import { render } from "./TaskFieldPopup.vue?vue&type=template&id=2ec9e073&ts=true"
import script from "./TaskFieldPopup.vue?vue&type=script&lang=ts"
export * from "./TaskFieldPopup.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__